/**
 * This code was generated by Builder.io.
 */
import React from "react";
import { PAYMENT_METHODS, paymentMethodDisplayNames, useAppSelector } from "@hypexone/uicore";

interface PaymentMethodProps {
  methods: PAYMENT_METHODS[];
  selectedPaymentMethod: PAYMENT_METHODS;
  onPaymentMethodClick: (paymentMethod: PAYMENT_METHODS) => void;
}

const PaymentMethod: React.FC<PaymentMethodProps> = ({
  methods,
  onPaymentMethodClick,
  selectedPaymentMethod,
}) => {
  const {langData} = useAppSelector((state) => state.cms);

  return (
    <div className="flex items-center text-base leading-none text-black w-full md:w-[400px] cursor-pointer">
      {methods.map((method, index) => {
        const isSelected = selectedPaymentMethod === method;
        return (
          <div
            onClick={() => onPaymentMethodClick(method)}
            key={index}
            className={`flex flex-1 flex-col self-stretch my-auto text-center`}
          >
            <div
              className={`gap-2.5 self-stretch px-4 py-2 ${
                isSelected
                  ? "bg-paymentPrimaryBg text-white border border-goldenYellow"
                  : "bg-stone-300 border-r border-paymentPrimaryBg"
              } h-[31px]`}
            >
              {(() => {
                const displayKey =
                  paymentMethodDisplayNames[
                    //@ts-ignore
                    method === "UPI" ? "UPI_TRANSFER" : method
                  ];
                const langKey = displayKey?.toLowerCase?.();
                return langData?.[langKey] ?? displayKey ?? method;
              })()}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default PaymentMethod;
